import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import GuardLayout from "../../Components/Layout/GuardLayout";
import AttendeeDetials from "../../Components/OrderMgt/Attendee/AttendeeDetials";
import useHttpHook from "../../Hooks/HttpHook";
import { GetAllAttendeeDetails } from "../../utils/ApiConstant";
import { showErrorToast } from "../../utils/notify";

const GuardAttendeeDetailsPage = () => {
  const { attendeeId } = useParams();
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.guard);
  const [details, setDetails] = useState({});
  const [loading, sendRequest, error] = useHttpHook();

  useEffect(() => {
    if (!token) {
      navigate("/guard/login", { replace: true });
      return;
    }
    getDetails();
  }, [attendeeId, token]);

  useEffect(() => {
    if (!error) {
      return;
    }
    if (toast.isActive(error) === false) {
      showErrorToast(error);
    }
    if (error === "You are unAuthrised") {
      navigate("/guard/login", { replace: true });
    }
  }, [error, navigate]);

  const getDetails = async () => {
    try {
      // Public attendee details endpoint — do not send a stale user Bearer token
      const response = await sendRequest(
        `${GetAllAttendeeDetails}/${attendeeId}`,
        {
          method: "get",
        },
        false
      );
      if (response?.status === 1) {
        setDetails(response.data);
      }
    } catch (fetchError) {
      console.log(fetchError);
    }
  };

  return (
    <GuardLayout
      Heading="Attendee Details"
      TitleMark={true}
      TitleMarkClassName="event-attendee-detail-title-mark"
      TitleClassName="event-attendee-detail-title"
      HeadClassName="event-attendee-detail-head"
      ExtraclassName="event-attendee-detail-panel"
      DetailsHead
      BackAction={"/guard/attendees"}
    >
      <AttendeeDetials
        isLoading={loading}
        isError={error}
        details={details}
        setDetails={setDetails}
      />
    </GuardLayout>
  );
};

export default GuardAttendeeDetailsPage;
